var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('the-nav-dialog-layout',{ref:"dialog",attrs:{"title":"外观设置","navs":_vm.navs},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var type = ref.type;
return [_c(type,{tag:"component"})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }